import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { focusColor } from "core/colors";
import { easingSeconds } from "core/animation";
const HomeLinkStyled = styled.a`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;

    transition: opacity ${easingSeconds} ease-in-out;

    &:hover {
        opacity: 0.6;
    }
    &:focus {
        border: none;
        outline: none;
        outline: solid ${convertPxToRem(4)} ${focusColor};
    }
`;

// links
import { homePath } from "data/links";

// component
export const HomeLink = ({
    className,
    children,
    onFocus,
    isDisabled = false
}) => {
    return (
        <HomeLinkStyled
            className={className}
            href={homePath.url}
            onFocus={onFocus}
            tabIndex={isDisabled ? -1 : 0}
            aria-disabled={isDisabled}
        >
            {children}
        </HomeLinkStyled>
    );
};

export default HomeLink;

// prop-types
HomeLink.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    onFocus: PropTypes.func,
    isDisabled: PropTypes.bool
};
